module.exports = __webpack_public_path__ + "media/images/icon-dynamic-pricing-dark-ad4bf9bf1baea2f3b07b823902cd8638.svg";